import React from "react";
import styled from "styled-components";

export var NavyPink = function NavyPink() {
  return React.createElement(
    Svg,
    { viewBox: "0 0 550 564.5", name: "Anyfin", alt: "Anyfin logotype" },
    React.createElement(Polygon, { points: "550 0 0 178.47 0 533.41 46.63 518.28 46.63 564.5 100.07 500.94 550 354.94 550 0" }),
    React.createElement(Path, {
      d: "M118,334.1l11.74-44.91,11.75,37.13Zm-2.87-69.28L81,387.86l25.07-8.31,5-19.22L148.38,348l5,15.9,25.08-8.32-34.1-100.43Z",
      transform: "translate(0 -0.5)"
    }),
    React.createElement(Path, {
      d: "M225.9,257.79c-9.46,3.14-16.63,9.34-20.49,16.53v-7.5l-21.5,7.12v79.82l21.5-7.13V303.06c0-11.34,5.44-18.25,13.32-20.86,6.88-2.28,12.46.49,12.46,10.39v45.49l21.5-7.12V282c0-21.55-12.32-28.95-26.79-24.16",
      transform: "translate(0 -0.5)"
    }),
    React.createElement(Path, {
      d: "M364.71,202.73a163.14,163.14,0,0,1,17.91-4.66V176a82,82,0,0,0-17.91,3.7c-23.79,7.89-34.82,23.36-34.82,45.71l-25.81,8.67-13.46,53.31-15.91-43.58-23.64,7.84,28.52,66.69c-3.16,10.78-7.89,15.86-17.91,19.18v22.35c20.06-5.53,32.81-19.81,40.83-47.85l17.25-60.25,10.13-3.38v56.83l21.49-7.13V241.31l18.34-6.08v56.82l21.49-7.12V205.12l-39.83,13.2c0-9.26,5.3-12.93,13.33-15.59",
      transform: "translate(0 -0.5)"
    }),
    React.createElement(Path, {
      d: "M446.1,184.69a35.8,35.8,0,0,0-20.49,16.53v-7.51l-21.49,7.13v79.81l21.49-7.12V230c0-11.33,5.44-18.25,13.32-20.86,6.88-2.28,12.47.5,12.47,10.4V265l21.49-7.13v-49c0-21.55-12.32-29-26.79-24.16",
      transform: "translate(0 -0.5)"
    })
  );
};

var Svg = styled.svg.withConfig({
  displayName: "NavyPink__Svg",
  componentId: "sc-1iyl8rs-0"
})(["height:100%;display:block;"]);

var Polygon = styled.polygon.withConfig({
  displayName: "NavyPink__Polygon",
  componentId: "sc-1iyl8rs-1"
})(["fill:", ";"], function (props) {
  return props.theme.colors.coreNavy;
});
var Path = styled.path.withConfig({
  displayName: "NavyPink__Path",
  componentId: "sc-1iyl8rs-2"
})(["fill:", ";"], function (props) {
  return props.theme.colors.corePink;
});